import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'
import { useInstitutionalStore } from '@/stores/institutionalStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnCancelCreateNewInstitutional',
  setup(__props) {

const router = useRouter()
const institutionalStore = useInstitutionalStore()

/**
 * ✅ Mostrar botão apenas quando estiver criando novo cadastro
 */
const showCancelButton = computed(() => {
  return !institutionalStore.institutionalDraft.id
})

/**
 * ✅ Voltar para tela de pesquisa
 */
const backToPreviousPage = () => {
  router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
}

return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (showCancelButton.value)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-cancel-create-new-institutional",
        propBtnLabel: "Cancelar",
        propBtnFunction: backToPreviousPage,
        propBtnTransparent: true,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})